(function () {
    'use strict';

    angular.module('app.shared', [
        'ngMessages',
        'ngAnimate',
        'ngSanitize',
        'ui.router',
        'ui.bootstrap',
        'app.core',
        'ui.validate',
        'chart.js',
        'ngDfp',
        'angular-duration-format.filter'
    ]);
})();